"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHighlightedMerchIdForEdition = exports.getAdditionalUnitsQuantityMinusIncluded = exports.isAdditionalUnitsMerchIdSameAsBaseMerchId = void 0;

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _getBaseProductForAdditionalUnitMerchId = function _getBaseProductForAdditionalUnitMerchId(products, additionalUnitMerchId) {
  return Object.keys(products).find(function (merchId) {
    return products[merchId].additionalUnitMerchId === additionalUnitMerchId;
  });
};

var isAdditionalUnitsMerchIdSameAsBaseMerchId = function isAdditionalUnitsMerchIdSameAsBaseMerchId(merchId) {
  return merchId === _ImmutableMerchandiseIdMap.default[merchId].additionalUnitMerchId;
};

exports.isAdditionalUnitsMerchIdSameAsBaseMerchId = isAdditionalUnitsMerchIdSameAsBaseMerchId;

var getAdditionalUnitsQuantityMinusIncluded = function getAdditionalUnitsQuantityMinusIncluded(products, inputAdditionalUnitsQuantity, additionalUnitsMerchId) {
  var baseProductMerchId = _getBaseProductForAdditionalUnitMerchId(products, additionalUnitsMerchId);

  if (baseProductMerchId && products[baseProductMerchId].includedAdditionalUnits) {
    return inputAdditionalUnitsQuantity - products[baseProductMerchId].includedAdditionalUnits;
  }

  return inputAdditionalUnitsQuantity;
};

exports.getAdditionalUnitsQuantityMinusIncluded = getAdditionalUnitsQuantityMinusIncluded;

var getHighlightedMerchIdForEdition = function getHighlightedMerchIdForEdition(hub, edition) {
  var highlightedMerchForHub = _HubMap.default[hub].highlightedPaidMerch;
  return highlightedMerchForHub.find(function (merchId) {
    return _ImmutableMerchandiseIdMap.default[merchId].edition === edition;
  });
};

exports.getHighlightedMerchIdForEdition = getHighlightedMerchIdForEdition;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/core/utilities/merchUtils.js
// module id = 463
// module chunks = 5 6